<template>
  <b-table :data="visibleRows" :striped="true">
    <b-table-column field="fieldName" label="Camp" v-slot="props">
      {{ label(props.row.fieldName) }}
    </b-table-column>
    <b-table-column field="oldValue" label="Valoare veche" v-slot="props">
      {{ value(props.row.fieldName, props.row.oldValue) }}
    </b-table-column>
    <b-table-column field="newValue" label="Valoare noua" v-slot="props">
      {{ value(props.row.fieldName, props.row.newValue) }}
    </b-table-column>
    <b-table-column field="reason" label="Motiv" v-slot="props">
      {{ props.row.reason }}
    </b-table-column>
    <b-table-column field="rectifiedAtUtc" label="Data" v-slot="props">
      {{ when(props.row.rectifiedAtUtc) }}
    </b-table-column>
    <b-table-column field="rectifiedByEmail" label="Utilizator" v-slot="props">
      {{ user(props.row) }}
    </b-table-column>
    <template #empty>
      <p class="has-text-grey has-text-centered">
        Dosarul nu a fost rectificat.
      </p>
    </template>
  </b-table>
</template>

<script>
import {
  fieldLabel,
  formatAuditValue,
  formatDateTime,
  fromApiUtc,
  isTechnicalField,
  userLabel,
} from "@/helpers/resdps";

export default {
  name: "SuccessionFileRectifications",
  props: {
    rectifications: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // Identificatorii interni (de ex. legatura cu registratura) nu se afiseaza.
    visibleRows() {
      return this.rectifications.filter(
        (row) => !isTechnicalField(row.fieldName)
      );
    },
  },
  methods: {
    label: fieldLabel,
    value: formatAuditValue,
    when(value) {
      return formatDateTime(fromApiUtc(value));
    },
    user(row) {
      return userLabel(row.rectifiedByEmail, row.rectifiedBySub);
    },
  },
};
</script>
